module.exports = __webpack_public_path__ + "static/media/QuickSwap - Smart Contract Security Report.5cd34614.pdf";